import React from 'react';
import styled from 'styled-components';
import YellowDisplayBox from '../../../common/YellowDisplayBox';
import SubheaderBox from '../SubheaderBox';
import {
  flexBoxCenter,
  justifyContentSpaceEvenly,
  layerHPA,
  layerHPB,
} from '../../../../styles/commonStyles';

const StationTelemetry = () => {
  const yellowDisplayData = ['1yd', '2yd', '3yd', '4yd', '5yd'];
  return (
    <Wrapper>
      <FirstLayer>
        <SubheaderBox
          title={'station live telemetry'}
          customCss={{ height: '22px', width: '860px', borderRadius: '12px' }}
          fontSize={'10px'}
          flexLeft={true}
        />
        <FlexWrapper>
          {yellowDisplayData.map((id, idx) => {
            const lastIdx = yellowDisplayData.length - 1;
            if (idx !== lastIdx) {
              return (
                <YellowDisplayBox
                  key={id}
                  wrapperXSize={'168px'}
                  wrapperYSize={'41px'}
                  innerXLayer={'160px'}
                  innerYLayer={'33px'}
                />
              );
            } else {
              return (
                <YellowDisplayBox
                  key={id}
                  wrapperXSize={'151px'}
                  wrapperYSize={'41px'}
                  innerXLayer={'143px'}
                  innerYLayer={'33px'}
                />
              );
            }
          })}
        </FlexWrapper>
      </FirstLayer>
    </Wrapper>
  );
};

export default StationTelemetry;

const Wrapper = styled.section`
  width: 875px;
  height: 81px;

  border-radius: 18px 18px 14px 14px;
  ${layerHPA}
  ${flexBoxCenter}
`;

const FirstLayer = styled.div`
  width: 869px;
  height: 77px;

  ${layerHPB}
  border-radius: 16px 16px 12px 12px;

  ${flexBoxCenter}
  flex-direction: column;
  gap: 4px;
`;

const FlexWrapper = styled.div`
  width: 100%;
  ${justifyContentSpaceEvenly}
`;
